module.exports = {
	"no": {
		"help-tool": {
			"button-text": "Hjelp",
			"support-button": "Få støtte",
			"support-page": {
				"create-ticket": {
					"title": "Få støtte",
					"instructions": "Send inn en forespørsel nedenfor, så kommer vi tilbake til deg innen 1 virkedag.",
					"related-content": {
						"title": "Disse kan hjelpe deg med å løse problemet"
					},
					"fields": {
						"mid": {
							"label": "Velg butikk",
							"validation": "Butikk kreves"
						},
						"phoneNumber": {
							"label": "Telefonnummer (valgfritt)"
						},
						"topic": {
							"question": "Hva er spørsmålet ditt relatert til?",
							"label": "Velg et emne",
							"validation": "Emne kreves",
							"options": {
								"orders": "Ordre",
								"settlements": "Oppgjør",
								"agreements": "Avtaler",
								"others": "Andre"
							}
						},
						"subject": {
							"label": "Emne",
							"validation": "Tema kreves"
						},
						"description": {
							"label": "Beskjed",
							"validation": "Beskrivelse kreves"
						},
						"attachment": {
							"label": "Legg til vedlegg",
							"button": "Last opp",
							"info": "Å legge til skjermbilder vil hjelpe oss med å løse problemet raskere.",
							"supportedFileTypes": "Støttede filtyper: .png, .jpg, .pdf",
							"error": "Total filstørrelse kan ikke overstige {maxSize} MB"
						}
					},
					"submit": "Send forespørsel",
					"service-unavailable-error": "Oisann! Noe gikk galt, prøv igjen om noen minutter. Hvis problemet vedvarer, {link} for hjelp.",
					"generic-error": "Vi kunne ikke behandle forespørselen din. Systemene våre snakker ikke med hverandre akkurat nå. Prøv å oppdatere, eller kom tilbake senere. Hvis dette fortsetter, {link} for hjelp.",
					"contact-link": "kontakt oss"
				},
				"view-ticket": {
					"title": "Ferdig!",
					"details": "Vi har mottatt forespørselen din, og vi vil gi deg svar innen 1 virkedag. Her er detaljene dine:",
					"ticket": "Be om #{ticketId}",
					"email": "E-post: {email}",
					"status": "Du kan spore statusen på supportsiden vår.",
					"track": "Spor status"
				}
			},
			"header": {
				"homeLink": "Tilbakestill"
			},
			"home": {
				"greeting": "Hei {givenName}! Hvordan kan vi hjelpe deg?",
				"topics": "Hva trenger du hjelp med?"
			},
			"topics": {
				"expandButton": "Mer"
			},
			"feedback": {
				"title": "Var dette til hjelp?",
				"optionYes": "Ja, dette var nyttig",
				"optionNo": "Nei, jeg trenger mer hjelp",
				"positiveFeedback": "Takk for positiv tilbakemelding, dette hjelper oss med å gi deg mer relevante artikler i fremtiden."
			},
			"freeTextFeedback": {
				"title": "Hjelp oss å bli bedre",
				"placeholder": "Hvorfor synes du ikke at dette innholdet var nyttig?",
				"submitButton": "Send",
				"feedbackMessage": "Takk for din tilbakemelding, dette hjelper oss med å gi deg mer relevante artikler i fremtiden."
			},
			"relatedContent": {
				"title": "Relatert innhold"
			},
			"search": {
				"buttonLabel": "Søk",
				"input": "Søk etter artikler ...",
				"loading": "Laster inn ...",
				"results": {
					"contact": "Finner du ikke hjelpen du trenger?",
					"empty": "Beklager, vi fant ingen resultater for søket ditt. Prøv å søke etter et annet begrep.",
					"singleTopicFound": "Vi fant 1 emne",
					"multipleTopicsFound": "Vi fant {count} emner",
					"singleArticleFound": "Vi fant 1 artikkel",
					"multipleArticlesFound": "Vi fant {count} artikler"
				}
			},
			"contact": {
				"title": "Kontakt oss",
				"channelsIntro": "Kontakt oss slik at vi kan hjelpe deg.",
				"businessDetailsTitle": "Forretningsinformasjonen din",
				"businessDetailsName": "Firmanavn",
				"businessDetailsEmail": "E-post",
				"businessDetailsMid": "Butikk-ID",
				"phone": {
					"title": "Ring oss",
					"paragraph": "Du kan ringe oss i arbeidstiden på hverdager. Hvis du befinner deg i Sverige eller Storbritannia, kan du også ringe oss i helgen mellom kl. 10.00 og 16.00."
				},
				"email": {
					"title": "Send oss en e-post",
					"paragraph": "Send oss en e-post, så kommer vi tilbake til deg så snart vi kan."
				}
			},
			"errorBoundary": {
				"title": "Noe gikk galt",
				"message": "Vi beklager, men det oppsto en feil. Du kan klikke på \"Gå tilbake\"-knappen nedenfor for å gå tilbake til hjelpeverktøyet eller \"Få hjelp\"-knappen for å kontakte oss.",
				"resetButton": "Gå tilbake",
				"errorId": "Feil-ID: {errorId}"
			},
			"tour": {
				"prev": "Forrige",
				"next": "Neste",
				"done": "Ferdig"
			},
			"notAvailableMobile": {
				"title": "Ikke tilgjengelig",
				"buttonBack": "Tilbake",
				"paragraph": "Dette innholdet er ikke tilgjengelig på enheten din. Prøv å åpne på en enhet med større skjermstørrelse, for eksempel en stasjonær datamaskin."
			},
			"shareButton": {
				"title": {
					"article": "Del en dyp lenke til denne artikkelen",
					"topic": "Del en dyp lenke til dette emnet",
					"tour": "Del en dyp lenke til denne turen"
				},
				"radioItemHome": "Hjem-app",
				"descriptionHome": "Åpner hjelpeartikkelen på Merchant Portal-hjemmesiden",
				"radioItemCurrent": "Nåværende side",
				"descriptionCurrent": "Åpner hjelpeartikkel på gjeldende side"
			},
			"marketSelector": {
				"whichMarketToContact": "Hvilket marked ønsker du å kontakte?"
			}
		},
		"orientation": {
			"title": "Lær hvordan man lager ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hei {name}! 👋 Jeg er din Klarna-assistent.",
				"whatDoYouNeedHelpWithPart2": "I mange tilfeller vil bruk av meg hjelpe deg med å løse spørsmålet ditt på mindre enn 5 minutter.",
				"whatDoYouNeedHelpWithPart3": "Hva kan jeg hjelpe deg med i dag?",
				"selectSupportChannel": "Velg en kanal for å kontakte vår supporttjeneste.",
				"selectPayoutIssue": "Perfekt! Gå videre og velg et utbetalingsrelatert problem 👇",
				"selectOrderIssue": "Perfekt! Gå videre og velg et ordrerelatert problem 👇",
				"capturedOrders": "Har du noen {link1}-ordrer?",
				"capturedOrdersLink1": "levert",
				"notPaidOrder": {
					"isScheduleFollowed": "Blir din {link1} (inkludert utbetalingsforsinkelse) fulgt?",
					"isScheduleFollowedLink1": "utbetalingsplan",
					"isHoldbackOrDebt": "Hvis utbetalingsforsinkelsen er overskredet, vennligst sjekk din {link1}. Er det noe tilbakehold eller gjeld på grunn av returer/reverseringer?",
					"isHoldbackOrDebtLink1": "siste oppgjørsfil"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Bekreft leveringsdatoen for ordrene du forventet å få utbetalt, og ta hensyn til utbetalingsforsinkelsen din. Du finner ordrene dine {link1}. Er ordrene som forventes å utbetales levert?",
					"isScheduleFollowedLink1": "her"
				},
				"changePaymentFrequency": "Har du mottatt mer enn 30 leverte ordrer per måned over en 3 måneders periode?",
				"whenWillGetPaid": "Utbetalingsdatoen vil avhenge av utbetalingsplanen din og utbetalingsforsinkelsen som er oppgitt i kontrakten din (vilkår og betingelser). Hvis du ikke er sikker på hva utbetalingsoppsettet ditt er, kan du sjekke det i {link1}. Blir utbetalingsplanen (+utbetalingsforsinkelse) fulgt?",
				"whenWillGetPaidLink1": "Oppgjør",
				"thatHelped": "Takk for den positive tilbakemeldingen, dette hjelper oss mye med å gi deg mer relevant hjelp i fremtiden. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Aha, jeg skjønner! Har du noen ordrer som ikke er levert?",
					"haveUncapturedOrdersPart2": "Hvis du ikke vet hvordan du sjekker dette, vennligst gå til {link1}.",
					"haveUncapturedOrdersPart2Link1": "denne siden",
					"expirationDateSurpassed": "Har utløpsdatoen passert? (vanligvis 28 dager)",
					"customerCreditPaymentMethod": "Valgte kunden en kredittbetalingsmetode (faktura, konto, direktebetaling)?",
					"isOrderCaptured": "Er ordren {link1}?",
					"isOrderCapturedLink1": "levert"
				}
			},
			"options": {
				"payout": "Utbetaling",
				"orders": "Ordre",
				"otherIssue": "Andre utfordringer",
				"whenPaidOrderNext": "Når får jeg betalt neste gang?",
				"notPaidOrder": "Jeg fikk ikke betalt",
				"paidWrongAmount": "Jeg fikk betalt feil beløp",
				"changeHowOftenPaid": "Jeg ønsker å endre hvor ofte jeg får betalt",
				"dontKnowHowToCaptureOrder": "Jeg vet ikke hvordan jeg leverer en ordre",
				"missedCaptureDeadline": "Jeg gikk glipp av leveringsfristen",
				"needToRefundAnOrder": "Jeg må refundere er ordre",
				"yes": "Ja",
				"no": "Nei",
				"partially": "Delvis",
				"iNeedMoreHelp": "Jeg trenger mer hjelp",
				"thatHelped": "Det hjalp",
				"contactSupportChannel": "Kontakt supportkanaler"
			},
			"explanations": {
				"noCapturedOrders": "Det første først, du må {link1}. Så snart du har levert ordren, utbetaler vi beløpet til bankkontoen din. Gebyrer, returer og andre avgifter vil bli trukket fra dette beløpet.",
				"noCapturedOrdersLink1": "levere en ordre",
				"feesReturnsHoldbacks": "Gebyrer, returer og andre avgifter kan bli trukket fra det utbetalte beløpet. Vennligst sjekk om du har tilbakehold eller gjeld på grunn av returer/reverseringer i {link1}.",
				"feesReturnsHoldbacksLink1": "siste oppgjørsfil",
				"notPaidOrder": {
					"scheduleFollowed": "Når du har levert en ordre, utbetaler vi beløpet til bankkontoen din i henhold til utbetalingsplanen din. Gebyrer, returer og andre avgifter vil bli trukket fra dette beløpet. Vennligst sjekk verdien av utbetalingen din i {link1}.",
					"scheduleFollowedLink1": "siste oppgjørsfil",
					"noHoldback": "Kontroller at du har de riktige bankkontoopplysningene registrert for valutaen for utbetalingen {link1}.",
					"noHoldbackLink1": "her",
					"withHoldback": "Hvis verdien av de leverte ordrene overstiger gjelden, må du kontrollere at du har de riktige bankkontoopplysningene registrert for valutaen for utbetalingen {link1}.",
					"withHoldbackLink1": "her"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Du vil motta neste utbetaling i henhold til utbetalingsplanen + utbetalingsforsinkelse."
				},
				"changePaymentFrequency": {
					"isAble": "Fortsett ved å kontakte vår kundestøtte via kanalene nedenfor.",
					"isUnable": "Dessverre oppfyller du ikke kravene for å endre utbetalingsplanen din."
				},
				"orders": {
					"uncapturedDynamicYes": "Aha, jeg ser at du har {number} uleverte ordrer.",
					"uncapturedDynamicNo": "Jeg kan se at du ikke har uleverte ordrer",
					"uncapturedYesPart1": "Da er det tid for å levere noen ordrer da! Slik gjør du det:",
					"uncapturedYesPart2": "1. Gå til Ordrer-siden {link1}.",
					"uncapturesYesPart2Link1": "ved å klikke her",
					"uncapturedYesPart3": "2. Klikk på Klarna-referansen på ordren du ønsker å levere",
					"uncapturedYesPart4": "3. Velg artiklene eller legg til et beløp du vil levere",
					"uncapturedYesPart5": "4. Trykk på «Lever»",
					"uncapturedNoPart1": "For å levere en ordre må du første ha ordrer til levering.",
					"uncapturedNoPart2": "Å levere en ordre betyr å bekrefte at ordren har blitt sendt til kunden. Dette skal alltid gjøres samme dag som ordren blir sendt for hver ordre. Når du leverer en ordre, gir du oss også beskjed om at vi bør utløse en utbetaling til deg for den ordren. Les mer om hvordan du leverer en ordre {link1}.",
					"uncapturedNoLink1": "her",
					"customerCreditPaymentMethodNo": "Dessverre kan vi ikke forlenge en bestilling som har utløpt. Du må gjenopprette ordren.",
					"expirationDateSurpassedYes": "La oss hjelpe deg med å forlenge ordren. Vennligst kontakt vår support via en av kanalene nedenfor.",
					"expirationDateSurpassedNo": "Gå til {link1}. Velg ordren ved å huke av i boksen ved siden av Klarna-referansenummeret. Klikk på Forleng utløpsdatoen og bekreft forespørselen din.",
					"expirationDateSurpassedNoLink1": "Ordrer > Til levering",
					"isOrderCapturedYesPart1": "Velg varene du ønsker å refundere og klikk på Refusjon. Du kan også klikke på Refusjon først, og legge inn beløpet du vil tilbakebetale – du velger hvilken måte som fungerer best for deg.",
					"isOrderCapturedYesPart2": "Kunden vil få refundert beløpet vedkommende allerede har betalt innen 2–5 virkedager. Dette beløpet vil trekkes fra din neste utbetaling.",
					"isOrderCapturedNo": "Hvis du har en ulevert ordre som du ikke vil sende, kan du {link1} hele ordren. Gå til {link2} og klikk på Avbryt ordre.",
					"isOrderCapturedNoLink1": "avbryt",
					"isOrderCapturedNoLink2": "ordreside",
					"refundPartiallyCaptured": "Hvis ordren er delvis levert for varer du sendte og du ikke vil oppfylle resten, bør du frigi den delen av ordren som ikke er levert. Gå til {link1}, klikk på Flere handlinger og velg Frigi.",
					"refundPartiallyCapturedLink1": "ordreside"
				}
			},
			"messages": {
				"sorryToHearThat": "Jeg er lei for å høre at jeg ikke var til hjelp. Du vil snart bli omdirigert til å kontakte vår kundestøtte."
			},
			"button": {
				"label": "Få hjelp"
			},
			"contact": {
				"chat": "Chat med agent",
				"ticket": "Send inn billett",
				"times": {
					"minutes": "Ventetid: {time} minutt(er)",
					"hours": "Ventetid: {time} time(r)",
					"days": "Ventetid: {time} dag(er)"
				}
			}
		}
	}
};